import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import ContactUsComponent from '../../components/ContactUsComponent';
import { Helmet } from 'react-helmet-async';

const bodyContainer = [
    {
        name: "IT & Business Consultation",
        link: "it-business-consulting",
        imgPath: "../images/it-business-consultation.jpg"
    },
    {
        name: "Development Center Services",
        link: "development-center-services",
        imgPath: "../images/development-center-services.jpg"
    },
    {
        name: "Extended Team Services",
        link: "extended-team-services",
        imgPath: "../images/extended-team-services.jpg"
    }
]

const Services = () => {
    return (
        <div className="bg-[#F4F5FA] w-full flex flex-col">
            <Helmet>
                <title>Data Repo | IT Consulting, Development Center & Extended Team Services</title>
                <meta
                    name="description"
                    content="Data Repo provides IT and business consulting, dedicated development center services, and extended team models to help companies build and scale intelligent software solutions."
                />
            </Helmet>

            <section
                style={{ backgroundImage: `url('../images/service-hero.jpg')`, backgroundSize: "100% 60vh" }}
                className="hero--container relative flex flex-col justify-center w-full h-[60vh] bg-no-repeat bg-fixed md:bg-origin-border pt-[65px]">
                <h1 className="text-center text-white text-2xl md:text-5xl font-bold uppercase">IT Consulting & Software Development Services</h1>
                <div className="row--image-style bg-transparent w-full absolute bottom-0 left-0 right-0">
                    <svg className="waves w-full h-44" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 300" preserveAspectRatio="none">
                        <path fill="rgb(226 232 240)" d="M 1000 280 l 2 -253 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -235 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z"></path>
                        <path fill="rgb(100 116 139)" d="M 1000 261 l 2 -222 c -157 -43 -312 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -153.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 16.61 v 22.39 z"></path>
                        <path fill="#F4F5FA" d="M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z"></path>
                    </svg>
                </div>
            </section>

            <h2 className="text-3xl font-bold text-center mt-10 mb-4">
                Our Service Models
            </h2>

            <section className="px-6 md:px-16 py-4 text-center max-w-5xl mx-auto">
                <p className="text-lg text-gray-700">
                    Data Repo offers strategic IT consulting, dedicated development center services,
                    and extended software teams to help businesses design, build, and scale intelligent
                    digital products with modern technologies.
                </p>
            </section>

            <section className="body--container w-full px-4 py-8 my-5 md:py-10 md:px-12 lg:px-16 xl:px-20 2xl:px-24 flex flex-col md:flex-row gap-16 md:gap-8">
                {bodyContainer.map((item, index) => (
                    <div
                        key={index}
                        style={{ backgroundImage: `url('${item.imgPath}')`, backgroundSize: "100% 320px" }}
                        className="body--view w-full h-80 py-8 px-6 rounded-md bg-no-repeat bg-cover flex flex-row items-end hover:bg-slate-500">

                        <h4 className="text-center w-full text-white text-2xl md:text-sm lg:text-2xl font-semibold">{item.name}</h4>
                        <Link
                            to={item.link}
                            aria-label={`Learn more about ${item.name}`}
                            title={`${item.name} offered by Data Repo`}
                            className={`w-12 h-12 p-4 rounded-full bg-transparent text-white flex flex-col justify-center items-center border-2 hover:text-slate-500 hover:border-slate-500`}
                            onClick={() => { }}>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </Link>
                    </div>
                ))}
            </section>
            <ContactUsComponent />

        </div>
    )
}

export default Services;